/* Color Swatch */
document.addEventListener('click', function(e) {
  const swatch = e.target.closest('.color-swatch');
  if (!swatch) return;
  const wrapper = swatch.closest('.card-color-swatches');

  wrapper.querySelectorAll('.color-swatch').forEach(item => {
    item.classList.remove('active');
  });
  swatch.classList.add('active');
  const imageUrl = swatch.dataset.image;
  const card = swatch.closest('.card-wrapper');
  const productImage = card.querySelector('.media img');
  if (productImage && imageUrl) {
    productImage.src = imageUrl;
    productImage.srcset = '';
  }
  const productLink = card.querySelector('.full-unstyled-link');
  if (productLink) {
    productLink.href = swatch.dataset.url;
  }
});